"use client";

import { useLanguage } from "@/i18n/LanguageContext";

export default function ContactAssistanceSection() {
  const { t } = useLanguage();

  return (
    <section className="bg-[#064e3b] py-12 md:py-16 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-xl md:text-[28px] font-black text-white text-center mb-4">
          {t("access.h2Contact")}
        </h2>
        <p className="text-[#fefce8] text-center max-w-[720px] mx-auto mb-10 leading-relaxed">
          {t("access.contactIntro")}
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-[900px] mx-auto">
          {/* Phone */}
          <div className="bg-[#064e3b]/50 border-t-[3px] border-[#047857] p-5 text-center">
            <div className="text-[#fbbf24] text-sm font-bold uppercase tracking-wider mb-2">
              {t("access.contactPhoneLabel")}
            </div>
            <a
              href="tel:+17863774452"
              className="block text-white text-xl md:text-[22px] font-bold hover:text-[#fbbf24] transition-colors mb-1"
            >
              (786) 377-4452
            </a>
            <p className="text-[#fefce8]/80 text-sm">{t("access.contactPhoneHours")}</p>
          </div>

          {/* Email */}
          <div className="bg-[#064e3b]/50 border-t-[3px] border-[#047857] p-5 text-center">
            <div className="text-[#fbbf24] text-sm font-bold uppercase tracking-wider mb-2">
              {t("access.contactEmailLabel")}
            </div>
            <a
              href="mailto:contact@impact-window-repair-miami.com"
              className="block text-white text-base font-bold hover:text-[#fbbf24] transition-colors mb-1 break-all"
            >
              contact@impact-window-repair-miami.com
            </a>
            <p className="text-[#fefce8]/80 text-sm">{t("access.contactEmailResponse")}</p>
          </div>

          {/* Mail */}
          <div className="bg-[#064e3b]/50 border-t-[3px] border-[#047857] p-5 text-center">
            <div className="text-[#fbbf24] text-sm font-bold uppercase tracking-wider mb-2">
              {t("access.contactMailLabel")}
            </div>
            <p className="text-white text-base font-semibold leading-relaxed">
              848 Brickell Ave, PH-5<br />
              Miami, FL 33131
            </p>
            <p className="text-[#fefce8]/80 text-sm mt-1">{t("access.contactMailRole")}</p>
          </div>
        </div>
      </div>
    </section>
  );
}